import { observable } from 'mobx';

export class PlaylistModel {
  @observable
  sync: {[playlistId: string]: Array<string>} = {};

  @observable
  tracks: {[playlistId: string]: Array<string>} = {};

  @observable
  removed: {[playlistId: string]: Array<string>} = {};
}